export default {
    has(key) {

        if (localStorage.getItem(key)) {
            let record = localStorage.getItem(key);
            record = JSON.parse(record);

            if (record.timestamp - (Number(new Date())) > 0) {
                return true;
            }
        }

        return false;
    },

    remove(key){
        if(localStorage.getItem(key)){
            localStorage.removeItem(key)
        }
    },

    get(key) {
        if (this.has(key)) {
            let record = localStorage.getItem(key);
            record = JSON.parse(record);
            return JSON.parse(record.value);
        }

        return null;
    },

    set(key, value) {
        let record = {
            value: JSON.stringify(value),
            timestamp: Number((new Date()).setMonth((new Date()).getMonth()+13))
        };

        localStorage.setItem(key, JSON.stringify(record));

    }
}


// WEBPACK FOOTER //
// ./vendor/bbs/crt/src/resources/js/utils/LocaleStorage.js